import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countTrueFromObject',
})
export class CountTrueFromObjectPipe implements PipeTransform {
  transform(value: { [index: string | number]: boolean }): string {
    if (typeof value !== 'object') return '';

    return Object.values(value)
      .filter((v) => v)
      .length.toString();
  }
}
